import React, { useState } from "react";
import styles from "./Login.module.css";
import Logo from "../../components/Logo";
import IcEye from "../../components/Svg/IcEye";
import { Form } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Button from "../../components/Button";

export default function Login() {
  const { signIn } = useAuth();
  const [loginData, setloginData] = useState();

  const [loading, setloading] = useState();

  const handleLogin = async () => {
    setloading(true);
    try {
      await signIn({
        email: loginData?.email,
        password: loginData?.password,
      });
      // navigate(from, { replace: true });
    } catch (__error) {
      console.log(__error);
    } finally {
      setloading(false);
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={`${styles.wrapLogin} ${styles._gestor}`}>
      <div className="text-center">
        <Logo />
        <p className="mt-3">
          Fazer Login no Painel do <b style={{ fontSize: "1.5em" }}>Gestor</b>
        </p>
      </div>
      <Form onSubmit={handleLogin}>
        <Form.Group className={`${styles.inputBox} lince-input`}>
          <span>Email</span>
          <div className="lince-input__text">
            <Form.Control
              type="email"
              autoCorrect="off"
              autoCapitalize="off"
              value={loginData?.email}
              onChange={__ev => {
                setloginData({
                  ...loginData,
                  email: __ev.target.value,
                });
              }}
            />
          </div>
        </Form.Group>
        <Form.Group className={`${styles.inputBox} lince-input mt-2`}>
          <span>Senha</span>
          <div className="position-relative">
            <Form.Control
              autoCorrect="off"
              autoCapitalize="off"
              type={showPassword ? `text` : `password`}
              value={loginData?.password}
              onChange={__ev => {
                setloginData({
                  ...loginData,
                  password: __ev.target.value,
                });
              }}
            />
            <i className={`showPassword ${styles.showPassword}`} onClick={() => setShowPassword(!showPassword)}>
              <IcEye />
            </i>
          </div>
        </Form.Group>
        <div className={`${styles.controlesLogin}`}>
          <NavLink to="/password-recovery?t=g" className="esqueciSenha">
            Redefinir Senha
          </NavLink>
        </div>
        <Button
          color="secondary"
          loading={loading}
          onClick={() => {
            handleLogin();
          }}
          className="w-100 mt-4 p-4"
        >
          Entrar como Gestor
        </Button>
      </Form>
    </div>
  );
}
